/**
 * ============================================================
 *
 * [home]
 * 
 * ============================================================
 */

let currentPanel = null;

/* headerの高さを代入 */
(function () {

  function setHeaderHeight() {
    const headerInner =
      document.querySelector('header .inner') ||
      document.querySelector('header');

    if (!headerInner) return;

    // レイアウト確定後に取得
    requestAnimationFrame(() => {
      const h = headerInner.getBoundingClientRect().height;

      // 0px のときは更新しない
      if (h > 0) {
        document.documentElement.style.setProperty('--header-h', h + 'px');
      }
    });
  }

  // 初期化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setHeaderHeight);
  } else {
    setHeaderHeight();
  }

  // 各種イベント
  window.addEventListener('load', setHeaderHeight);
  window.addEventListener('resize', setHeaderHeight);

  // Shopify Theme Editor 対応
  document.addEventListener('shopify:section:load', setHeaderHeight);
  document.addEventListener('shopify:section:unload', setHeaderHeight);

})();

/* キービジュアル */
$(function () {
    const $slider = $('#kv_area .slider');

    $slider.slick({
        fade: true,
        speed: 2000,
        autoplay: true,
        autoplaySpeed: 4000,
        arrows: false,
        dots: false,
        pauseOnHover: false,
        pauseOnFocus: false,
        infinite: true
    });

    // スクロールでKVに戻ったら必ず再生（スマホ最重要）
    const kv = document.querySelector('#kv_area');
    if ('IntersectionObserver' in window && kv) {
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    $slider.slick('slickPlay');
                }
            });
        }, { threshold: 0.3 });

        observer.observe(kv);
    }

    // タブ・画面復帰対策
    document.addEventListener('visibilitychange', function () {
        if (!document.hidden) {
            $slider.slick('slickPlay');
        }
    });

    // iOS用タッチ復帰
    document.addEventListener('touchstart', function () {
        if ($slider.hasClass('slick-initialized')) {
            $slider.slick('slickPlay');
        }
    }, { passive: true });
});

/* concept */
document.addEventListener('DOMContentLoaded', () => {
    const concept = document.querySelector('#concept_area');
    if (!concept) return;

    const ps = concept.querySelectorAll('.txt p');
    let played = false; // 初回のみ制御

    const mo = new MutationObserver(() => {
        if (
            concept.classList.contains('show_element') &&
            !played
        ) {
            played = true;

            // h2 を初回のみ表示
            concept.classList.add('is-played');

            // p を順番に表示
            ps.forEach((p, i) => {
                setTimeout(() => {
                    p.classList.add('is-show');
                }, 400 + i * 250);
            });
        }
    });

    mo.observe(concept, {
        attributes: true,
        attributeFilter: ['class']
    });
});

/* ラインナップ カラーチップ 色変更 */
document.addEventListener("DOMContentLoaded", function () {

    const defaultActiveIndex = [0, 2, 1, 0];

    document.querySelectorAll(".list article").forEach((article, articleIndex) => {

        const baseImg = article.querySelector(".img_base");       // 下の固定画像
        const overlayImg = article.querySelector(".img_overlay"); // 上書きフェード用
        const buttons = article.querySelectorAll(".color_chip button");

        // 必須要素チェック
        if (!baseImg || !overlayImg || !buttons.length) return;

        // プリロード
        buttons.forEach(btn => {
            if (btn.dataset.img) {
                const img = new Image();
                img.src = btn.dataset.img;
            }
        });

        // -------------------------
        // 初期アクティブ設定
        // -------------------------
        const activeIndex = defaultActiveIndex[articleIndex] ?? 0;

        buttons.forEach((btn, i) => {
            btn.classList.toggle("is-active", i === activeIndex);
        });

        const defaultBtn = buttons[activeIndex];
        if (defaultBtn?.dataset.img) {
            baseImg.src = defaultBtn.dataset.img;
        }

        // -------------------------
        // 上書きフェード切替
        // -------------------------
        let isAnimating = false;

        buttons.forEach(btn => {
            btn.addEventListener("click", () => {

                if (isAnimating) return;

                const newSrc = btn.dataset.img;
                if (!newSrc || newSrc === baseImg.src) return;

                isAnimating = true;

                // 先に overlay にロード
                overlayImg.onload = () => {
                    overlayImg.classList.add("is-show");

                    setTimeout(() => {
                        // フェード完了後に base を更新
                        baseImg.src = newSrc;

                        overlayImg.classList.remove("is-show");
                        isAnimating = false;
                    }, 400); // CSSのtransitionと同じ
                };

                overlayImg.src = newSrc;

                // ボタンの is-active 更新
                buttons.forEach(b => b.classList.remove("is-active"));
                btn.classList.add("is-active");
            });
        });
    });
});

/* ラインナップ カラーチップ 位置調整 ＋ 共通モーダル */
document.addEventListener('DOMContentLoaded', () => {
    // ============================================================
    // explanation 高さ揃え
    // ============================================================
    function alignColorChipByExplanation() {
        const articles = document.querySelectorAll(".list article");
        let maxHeight = 0;
        
        // リセット
        articles.forEach(article => {
            const exp = article.querySelector(".explanation");
            if (exp) exp.style.minHeight = "auto";
        });
        // 最大高さ取得
        articles.forEach(article => {
            const exp = article.querySelector(".explanation");
            if (!exp) return;

            const h = exp.offsetHeight;
            if (h > maxHeight) maxHeight = h;
        });
        // 最大値を適用
        articles.forEach(article => {
            const exp = article.querySelector(".explanation");
            if (exp) exp.style.minHeight = maxHeight + "px";
        });
    }
    alignColorChipByExplanation();
    // resize の負荷を下げる（debounce）
    let resizeTimer;
    window.addEventListener("resize", () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(alignColorChipByExplanation, 100);
    });

    // ============================================================
    // 共通モーダル基盤
    // ============================================================
    let scrollPosition = 0;
    let isClosing = false;

    // overlay
    let overlay = document.querySelector('.modal_overlay');
    if (!overlay) {
        overlay = document.createElement('div');
        overlay.className = 'modal_overlay';
        document.body.appendChild(overlay);
    }
    overlay.addEventListener('click', closeModal);
    function closeModal() {
        if (!currentPanel || isClosing) return;
        isClosing = true;
        currentPanel.classList.remove('is-show');
        overlay.classList.remove('is-show');
        // スクロールロック解除
        document.body.classList.remove('is-locked');
        document.body.style.top = '';
        window.scrollTo(0, scrollPosition);
        setTimeout(() => {
            if (currentPanel) currentPanel.remove();
            currentPanel = null;
            isClosing = false;
        }, 500);
    }

    // ============================================================
    // JSON キャッシュ（初回のみ通信）
    // ============================================================
    const jsonCache = {};
    async function loadJsonOnce(path) {
        if (jsonCache[path]) return jsonCache[path];
        try {
            const res = await fetch(path);
            if (!res.ok) throw new Error('JSON fetch failed');
            const json = await res.json();
            jsonCache[path] = json;
            return json;
        } catch (err) {
            console.error('JSON読み込み失敗:', path, err);
            return null;
        }
    }

    // ============================================================
    // JSON内画像 preload
    // ============================================================

    function preloadImagesFromJson(json) {
        if (!json || typeof json !== 'object') return;
        
        Object.values(json).forEach(block => {
            // items 内の画像
            if (Array.isArray(block.items)) {
                block.items.forEach(item => {
                    Object.keys(item).forEach(key => {
                        if (
                            key.includes('image') &&
                            typeof item[key] === 'string' &&
                            item[key].startsWith('http')
                        ) {
                            const img = new Image();
                            img.src = item[key];
                        }
                    });
                });
            }
            
            // items 外の画像
            [
                'image',
                'image_sub',
                'sub_image',
                'bg_pc',
                'bg_sp',
                'main_image_pc',
                'main_image_sp',
                'thumb'
            ].forEach(key => {
                if (
                    typeof block[key] === 'string' &&
                    block[key].startsWith('http')
                ) {
                    const img = new Image();
                    img.src = block[key];
                }
            });
        });
    }

    // ============================================================
    // 汎用モーダル生成関数
    // ============================================================
    function createDynamicModal({ triggerSelector, jsonPath, template }) {

        // document にデリゲーションで1回だけ張る
        document.addEventListener('click', async (e) => {
            const btn = e.target.closest(triggerSelector);
            if (!btn) return; // 対象以外は無視

            e.preventDefault();

            const article = btn.closest('[data-model]');
            const model = article?.dataset.model;
            if (!model) return;

            // すでにモーダルが開いていたら閉じてから差し替え
            if (currentPanel) {
                closeModal();
                await new Promise(r => setTimeout(r, 500));
            }

            const json = await loadJsonOnce(jsonPath);
            if (!json || !json[model]) return;

            const data = json[model];

            const panel = document.createElement('div');
            panel.className = 'modal_detail';
            panel.innerHTML = template(data);

            // スクロール固定
            scrollPosition = window.scrollY;
            document.body.classList.add('is-locked');
            document.body.style.top = `-${scrollPosition}px`;

            document.body.appendChild(panel);
            currentPanel = panel;

            // ★ product_list 用 slick
            initModalProductListSlick(panel);

            // 表示アニメ
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    panel.classList.add('is-show');
                    overlay.classList.add('is-show');
                });
            });

            // 閉じるボタン
            panel.querySelectorAll('.modal_close').forEach(btn => {
                btn.addEventListener('click', closeModal);
            });
        });
    }
    // ============================================================
    // 下スワイプで閉じる（共通）
    // ============================================================
    function setupSwipeToClose(panel) {
        let startY = 0;
        let currentY = 0;
        let isDragging = false;
        const inner = panel.querySelector('.modal_inner');
        panel.addEventListener('touchstart', e => {
            if (inner && inner.scrollTop !== 0) return;
            startY = e.touches[0].clientY;
            isDragging = true;
        });
        panel.addEventListener('touchmove', e => {
            if (!isDragging) return;
            currentY = e.touches[0].clientY;
            const diff = currentY - startY;

            if (diff > 0) {
                panel.style.transition = 'none';
                panel.style.transform = `translateY(${diff}px)`;
            }
        });
        panel.addEventListener('touchend', () => {
            panel.style.transition = '';
            if (!isDragging) return;
            isDragging = false;

            const diff = currentY - startY;
            if (diff > 80) {
                closeModal();
            } else {
                panel.style.transform = '';
            }

            startY = currentY = 0;
        });
    }

    // ============================================================
    // JSON preload（初回のみ）
    // ============================================================
    (async () => {
        if (window.JSON_PATHS?.feature) {
            const json = await loadJsonOnce(window.JSON_PATHS.feature);
            if (json) {
                preloadImagesFromJson(json);
            }
        }
        if (window.JSON_PATHS?.lineup) {
            await loadJsonOnce(window.JSON_PATHS.lineup);
            // lineup は画像が多いので preload しない or 必要なら別途
        }
    })();


    // ============================================================
    // コンテンツ別設定
    // ============================================================

    // こだわり
    createDynamicModal({
        triggerSelector: '.js-open-feature',
        jsonPath: window.JSON_PATHS.feature,
        template: featureTemplate
    });

    // ラインナップ
    createDynamicModal({
        triggerSelector: '.js-open-lineup',
        jsonPath: window.JSON_PATHS.lineup,
        template: lineupTemplate
    });

    // ============================================================
    // こだわり HTMLテンプレ
    // ============================================================
    function featureTemplate(data) {
        const items = Array.isArray(data.items) ? data.items : [];

        const tmplType = data.tmpl_type || 'type01';
        let featureBody = '';

        if (tmplType === 'feature02') {
            // type02
            featureBody = `
                <div class="feature_list">
                    ${items.map(item => `
                        <article>
                            ${item.lead ? `<p class="lead">${item.lead}</p>` : ''}
                            <ul>
                                <li>
                                    <figure>
                                        ${item.image01_img ? `<img src="${item.image01_img}" loading="lazy">` : ''}
                                        ${item.image01_caption ? `<figcaption>${item.image01_caption}</figcaption>` : ''}
                                    </figure>
                                </li>
                                <li>
                                    <figure>
                                        ${item.image02_img ? `<img src="${item.image02_img}" loading="lazy">` : ''}
                                        ${item.image02_caption ? `<figcaption>${item.image02_caption}</figcaption>` : ''}
                                    </figure>
                                </li>
                            </ul>
                            ${item.txt ? `<p class="txt">${item.txt}</p>` : ''}
                        </article>
                    `).join('')}
                </div>
                ${data.sub_title || data.sub_image || data.sub_txt ? `
                    <div class="facility">
                        <div class="item">
                            ${data.sub_title ? `<p class="sub_title">${data.sub_title}</p>` : ''}
                            ${data.sub_image ? `<figure><img src="${data.sub_image}" loading="lazy"></figure>` : ''}
                            ${data.sub_txt ? `<p class="txt">${data.sub_txt}</p>` : ''}
                        </div>
                    </div>
                ` : ''}
            `;
        } else if (tmplType === 'feature03') {
            // type03
            featureBody = `
                <div class="feature_list">
                    ${items.map(item => `
                        <article>
                            ${item.lead ? `<p class="lead">${item.lead}</p>` : ''}
                            ${item.image ? `<figure><img src="${item.image}" loading="lazy"></figure>` : ''}
                            ${item.txt ? `<p class="txt">${item.txt}</p>` : ''}
                        </article>
                    `).join('')}
                </div>
                ${data.sub_title || data.sub_image || data.sub_txt || data.profile ? `
                    <div class="pt_box">
                        ${data.sub_title ? `<p class="sub_title">${data.sub_title}</p>` : ''}
                        <div class="element">
                            ${data.sub_image ? `<figure><img src="${data.sub_image}" loading="lazy"></figure>` : ''}
                            <div class="item">
                                ${data.sub_txt ? `<p class="txt">${data.sub_txt}</p>` : ''}
                                ${data.profile ? `<p class="profile txt">${data.profile}</p>` : ''}
                            </div>
                        </div>
                    </div>
                ` : ''}
            `;
        } else if (tmplType === 'feature04') {
            // type04
            featureBody = `
                <div class="feature_list">
                    ${items.map(item => `
                        <article>
                            ${item.lead ? `<p class="lead">${item.lead}</p>` : ''}
                            ${item.image ? `<figure><img src="${item.image}" loading="lazy"></figure>` : ''}
                            ${item.txt ? `<p class="txt">${item.txt}</p>` : ''}
                        </article>
                    `).join('')}
                </div>
            `;
        } else if (tmplType === 'feature05') {
            // type05
            featureBody = `
                <div class="feature_list">
                    ${data.lead ? `<p class="lead">${data.lead}</p>` : ''}
                    <div class="element">
                        ${items.map(item => `
                            <article>
                                <figure>
                                    ${item.image ? `<img src="${item.image}" loading="lazy">` : ''}
                                    ${item.image_sub ? `<img src="${item.image_sub}" loading="lazy" class="sub">` : ''}
                                    ${item.caption ? `<figcaption>${item.caption}</figcaption>` : ''}
                                </figure>
                            </article>
                        `).join('')}
                    </div>
                    ${data.sub_txt ? `<p class="txt">${data.sub_txt}</p>` : ''}
                </div>
            `;
        } else if (tmplType === 'feature06') {
            // type06
            featureBody = `
                <div class="feature_list">
                    ${data.lead ? `<p class="lead">${data.lead}</p>` : ''}
                    <div class="element">
                        ${items.map(item => `
                            <article>
                                ${item.image ? `<figure><img src="${item.image}" loading="lazy"></figure>` : ''}
                                <div class="item">
                                    <h4>
                                        ${item.pro_name ? `<span class="title">${item.pro_name}</span>` : ''}
                                        ${item.pro_sub ? `<span class="sub">${item.pro_sub}</span>` : ''}
                                    </h4>
                                    ${item.txt ? `<p class="txt">${item.txt}</p>` : ''}
                                </div>
                            </article>
                        `).join('')}
                    </div>
                <div
            `;
        } else {
            // type01
            featureBody = `
                <div class="feature_list">
                    ${items.map(item => `
                        <article>
                            ${item.lead ? `<p class="lead">${item.lead}</p>` : ''}
                            ${item.image ? `<figure><img src="${item.image}" loading="lazy"></figure>` : ''}
                            ${item.txt ? `<p class="txt">${item.txt}</p>` : ''}
                        </article>
                    `).join('')}
                </div>
            `;
        }

        return `
            <div class="feature_modal modal_box">
                <button class="modal_close icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="none">
                        <path d="M20 2C29.93 2 38 10.07 38 20C38 29.93 29.93 38 20 38C10.07 38 2 29.93 2 20C2 10.07 10.07 2 20 2ZM20 0C8.95 0 0 8.95 0 20C0 31.05 8.95 40 20 40C31.05 40 40 31.05 40 20C40 8.95 31.05 0 20 0Z" fill="currentColor"/>
                        <path d="M29 13H26.3961L20 19.2374L13.6039 13H11L18.698 20.505L11 28H13.6039L20 21.7726L26.3961 28H29L21.302 20.505L29 13Z" fill="currentColor"/>
                    </svg>
                </button>
                <div class="modal_inner ${data.tmpl_type}">
                    <h3>${data.title || ''}</h3>
                    ${featureBody}
                    <div class="close_btn">
                        <button class="modal_close">
                            閉じる
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="none">
                                <path d="M20 2C29.93 2 38 10.07 38 20C38 29.93 29.93 38 20 38C10.07 38 2 29.93 2 20C2 10.07 10.07 2 20 2ZM20 0C8.95 0 0 8.95 0 20C0 31.05 8.95 40 20 40C31.05 40 40 31.05 40 20C40 8.95 31.05 0 20 0Z" fill="currentColor"/>
                                <path d="M29 13H26.3961L20 19.2374L13.6039 13H11L18.698 20.505L11 28H13.6039L20 21.7726L26.3961 28H29L21.302 20.505L29 13Z" fill="currentColor"/>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        `;
    }

    // ============================================================
    // ラインナップ HTMLテンプレ
    // ============================================================
    function lineupTemplate(data) {
        const items = Array.isArray(data.items) ? data.items : [];
        const currentModel = data.pro_type;
        const lineupKey = Object.keys(jsonCache).find(key => key.includes('lineup.json'));
        const allModels = lineupKey ? jsonCache[lineupKey] : {};
        const otherModels = Object.values(allModels).filter(item => {
            return item.pro_type !== currentModel;
        });
        return `
            <div class="lineup_modal modal_box">
                <button class="modal_close icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="none">
                        <path d="M20 2C29.93 2 38 10.07 38 20C38 29.93 29.93 38 20 38C10.07 38 2 29.93 2 20C2 10.07 10.07 2 20 2ZM20 0C8.95 0 0 8.95 0 20C0 31.05 8.95 40 20 40C31.05 40 40 31.05 40 20C40 8.95 31.05 0 20 0Z" fill="currentColor"/>
                        <path d="M29 13H26.3961L20 19.2374L13.6039 13H11L18.698 20.505L11 28H13.6039L20 21.7726L26.3961 28H29L21.302 20.505L29 13Z" fill="currentColor"/>
                    </svg>
                </button>
                <div class="modal_inner ${data.pro_type}">
                    <div class="pro_head">
                        <div class="item">
                            <h3>
                                <span class="title">${data.title || ''}</span>
                                <span class="sub">${data.subtitle || ''}</span>
                            </h3>
                            <p class="lead">${data.lead}</p>
                        </div>
                        <div class="bg">
                            <picture>
                                ${data.bg_sp ? `<source srcset="${data.bg_sp}" media="(max-width: 768px)">` : ''}
                                ${data.bg_pc ? `<img src="${data.bg_pc}" loading="lazy">` : ''}
                            </picture>
                        </div>
                        <div class="main">
                            <picture>
                                ${data.main_image_sp ? `<source srcset="${data.main_image_sp}" media="(max-width: 768px)">` : ''}
                                ${data.main_image_pc ? `<img src="${data.main_image_pc}" loading="lazy">` : ''}
                            </picture>
                        </div>
                    </div>
                    <div class="function_list">
                        ${items.map(item => `
                            <article>
                                <picture>
                                    ${item.image_sp ? `<source srcset="${item.image_sp}" media="(max-width: 768px)">` : ''}
                                    ${item.image_pc ? `<img src="${item.image_pc}" loading="lazy">` : ''}
                                </picture>
                                ${item.name ? `<h4 class="name">${item.name}</h4>` : ''}
                                <dl>
                                    ${item.lead ? `<dt class="lead">${item.lead}</dt>` : ''}
                                    ${item.txt ? `<dd class="txt">${item.txt}</dd>` : ''}
                                </dl>                                
                            </article>
                        `).join('')}
                    </div>
                    <div class="btn_buy">
                        <p class="link_element color_green">
                            <a href="${data.ec_url}" target="_blank">
                                ご購入はこちら
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 5 10" fill="none">
                                    <path d="M3.55769 5L0 8.55769V10L5 5L0 0V1.44231L3.55769 5Z" class="currentColor" />
                                </svg>
                            </a>
                        </p>
                    </div>
                    <div class="close_btn">
                        <button class="modal_close">
                            閉じる
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="none">
                                <path d="M20 2C29.93 2 38 10.07 38 20C38 29.93 29.93 38 20 38C10.07 38 2 29.93 2 20C2 10.07 10.07 2 20 2ZM20 0C8.95 0 0 8.95 0 20C0 31.05 8.95 40 20 40C31.05 40 40 31.05 40 20C40 8.95 31.05 0 20 0Z" fill="currentColor"/>
                                <path d="M29 13H26.3961L20 19.2374L13.6039 13H11L18.698 20.505L11 28H13.6039L20 21.7726L26.3961 28H29L21.302 20.505L29 13Z" fill="currentColor"/>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        `;
    }
});

/* Youtube サムネ再生 */
document.addEventListener("DOMContentLoaded", function () {
    const thumbnails = document.querySelectorAll(".youtube_tmb");
    thumbnails.forEach(thumbnail => {
        thumbnail.addEventListener("click", function () {
            const videoId = this.getAttribute("data-video-id");
            const iframe = document.createElement("iframe");
            iframe.setAttribute("src", `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`);
            iframe.setAttribute("frameborder", "0");
            iframe.setAttribute("allowfullscreen", "");
            iframe.setAttribute("allow", "autoplay; encrypted-media");
            iframe.style.width = "100%";
            iframe.style.height = "100%";
            this.parentNode.replaceChild(iframe, this);
        });
    });
});

/* こだわり スライダー */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.slider_wrap').forEach(function (wrap) {
    const $wrap   = $(wrap);
    const $slider = $wrap.find('.slider');
    const $articles = $slider.find('article');

    // ============================
    // 初期値セット（01,02...）
    // ============================
    $articles.each(function (i) {
      const num = i + 1;
      const tens = Math.floor(num / 10);
      const ones = num % 10;

      const $num = $(this).find('.num');
      $num.find('.tens').text(tens);
      $num.find('.ones').text(ones);
    });

    // ============================
    // 初期表示アニメーション
    // ============================
    $slider.on('init', function (event, slick) {
      animateNumber(slick.currentSlide);
      setActiveSlide(slick.currentSlide);
    });

    // ============================
    // Slick 初期化
    // ============================
    $slider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      autoplay: false,
      fade: true,
      speed: 1000,
      waitForAnimate: false,
      dots: true,
      arrows: true,
      prevArrow: $wrap.find('.slick_nav .prev'),
      nextArrow: $wrap.find('.slick_nav .next'),
      adaptiveHeight: false,
      cssEase: 'ease'
    });

    // ============================
    // 切り替え時：1の位だけ回す
    // ============================
    $slider.on('beforeChange', function (event, slick, current, next) {
      animateNumber(next);
    });

    $slider.on('afterChange', function (event, slick, current) {
      setActiveSlide(current);
    });

    // ============================
    // 表示切替
    // ============================
    function setActiveSlide(index) {
      const $current = $slider.find('.slick-slide').eq(index);
      $current.addClass('show_element')
        .siblings().removeClass('show_element');
    }

    // ============================
    // 1の位だけスロットアニメ
    // ============================
    function animateNumber(index) {
      const $slide = $slider.find('.slick-slide').eq(index);
      const num    = index + 1;
      const tens   = Math.floor(num / 10);
      const ones   = num % 10;

      const $num  = $slide.find('.num');
      const $tens = $num.find('.tens');
      const $ones = $num.find('.ones');

      // 十の位は即変更
      $tens.text(tens);

      // 1の位を下にスライド → 差し替え → 元に戻す
      $ones.css({
        transform: 'translateY(-100%)',
        opacity: 0
      });

      setTimeout(() => {
        $ones.text(ones);
        $ones.css({
          transform: 'translateY(0)',
          opacity: 1
        });
      }, 150);
    }
  });
});

/* ラインナップ */
$(function () {
    const breakpoint = 768;
    const $lists = $('#lineup_area .list');

    function toggleSlick($target) {
        if (window.innerWidth <= breakpoint) {
            // SP：slick 初期化
            if (!$target.hasClass('slick-initialized')) {
                $target.slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: false,
                    fade: false,
                    speed: 300,
                    cssEase: 'ease',
                    dots: false,
                    arrows: false,
                    adaptiveHeight: false,
                    autoplay: false,
                    variableWidth: true,
                    centerMode: false,
                    swipeToSlide: true,
                    initialSlide: 0,
                });
            }
        } else {
            // PC：slick 解除
            if ($target.hasClass('slick-initialized')) {
                $target.slick('unslick');
            }
        }
    }

    function initAllSlick() {
        $lists.each(function () {
            toggleSlick($(this));
        });
    }

    // 初期化 + リサイズ対応
    initAllSlick();
    $(window).on('resize', initAllSlick);
});

/* モーダル内 その他のモデル  */
function initModalProductListSlick(panel) {
    if (window.innerWidth > 768) return;

    const $list = $(panel).find('.other_area .product_list');
    if (!$list.length) return;

    if (!$list.hasClass('slick-initialized')) {
        $list.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            fade: false,
            speed: 300,
            cssEase: 'ease',
            dots: false,
            arrows: false,
            adaptiveHeight: false,
            autoplay: false,
            variableWidth: true,
            centerMode: false,
            swipeToSlide: true,
            initialSlide: 0,
        });
    } else {
        $list.slick('setPosition');
    }
}
window.addEventListener('resize', () => {
    if (!currentPanel) return;

    const $list = $(currentPanel).find('.other_area .product_list');
    if (!$list.length) return;

    if (window.innerWidth <= 768) {
        // SP に入ったら slick を当てる
        initModalProductListSlick(currentPanel);
    } else {
        // PC に出たら slick を外す
        if ($list.hasClass('slick-initialized')) {
            $list.slick('unslick');
        }
    }
});

/* THE PRIMEのある暮らし Slick  */
$(function () {
    const $lifeSlider = $('#life_area .inner .list');
    
    function initLifeSlider() {
        if (window.matchMedia('(max-width: 768px)').matches) {
            if (!$lifeSlider.hasClass('slick-initialized')) {
                $lifeSlider.slick({
                    centerMode: true,
                    slidesToShow: 1,
                    arrows: false,
                    dots: false,
                    infinite: false,
                    speed: 500,
                    cssEase: 'ease',
                    adaptiveHeight: false
                });
            }
        } else {
            if ($lifeSlider.hasClass('slick-initialized')) {
                $lifeSlider.slick('unslick');
            }
        }
    }
    
    initLifeSlider();

    $(window).on('resize', function () {
        initLifeSlider();
    });
});